import React from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { German } from "flatpickr/dist/l10n/de.js";

export type BottomFilterProps = {
  label?: string;
  startDate: Date | null;
  endDate: Date | null;
  onChange: (range: { startDate: Date; endDate: Date }) => void;
};

export const BottomFilter: React.FC<BottomFilterProps> = ({
  label = "Zeitraum",
  startDate,
  endDate,
  onChange,
}) => {
  const value: Date[] = [];
  if (startDate) value.push(startDate);
  if (endDate) value.push(endDate);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        justifyContent: "flex-start",
      }}
    >
      <label
        style={{
          fontSize: "0.9rem",
          color: "var(--grey)",
          fontWeight: 500,
          whiteSpace: "nowrap",
        }}
      >
        {label}:
      </label>
      <Flatpickr
        value={value}
        options={{
          mode: "range",
          dateFormat: "d.m.Y",
          locale: German,
          maxDate: "today",
        }}
        onChange={(dates) => {
          if (dates.length === 2) {
            onChange({ startDate: dates[0], endDate: dates[1] });
          }
        }}
        className="flatpickr-input"
        style={{
          width: "220px",
          border: "1px solid #ccc",
          borderRadius: "6px",
          padding: "6px 10px",
          fontSize: "14px",
          outline: "none",
          transition: "border-color 0.2s",
        }}
      />
    </div>
  );
};
